var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useLayoutEffect } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import Lottie from 'lottie-react';
import { adsApi } from 'api';
import { useAdManager, useResponsive, useToast } from 'hooks';
import { Button } from 'ui';
import { GAHandler } from 'utils/GA';
import { ReactComponent as CloseSVG } from 'assets/icons/exit.svg';
import loaderJson from 'assets/lotties/player-loader.json';
var PlayerInStream = function (props) {
    var close = props.close, onEnd = props.onEnd;
    var queryClient = useQueryClient();
    var _a = adsApi.useGetAd(), ad = _a.data, resetAd = _a.remove;
    var _b = adsApi.useGetNextReward(), nextReward = _b.data, resetNextReward = _b.remove;
    var _c = adsApi.usePostWatchedAd(), postWatchedAd = _c.postWatchedAd, isLoading = _c.isLoading;
    var _d = useAdManager(), startAd = _d.startAd, isEnded = _d.isEnded, duration = _d.duration, played = _d.played, adContainerRef = _d.adContainerRef, videoWrapperId = _d.videoWrapperId, isSkippable = _d.isSkippable, skipAd = _d.skipAd, error = _d.error;
    var t = useTranslation().t;
    var isMobileBig = useResponsive().isMobileBig;
    var toast = useToast().toast;
    var unfinishedClose = function () {
        GAHandler('ad_unfinished');
        // stopAd()
        close();
    };
    var handlePlay = function () { GAHandler('ad_presented'); };
    var handleEnd = function () { return __awaiter(void 0, void 0, void 0, function () {
        var updatedBalance;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, postWatchedAd({ id: ad.id })];
                case 1:
                    _a.sent();
                    GAHandler('ad_finished');
                    updatedBalance = queryClient.getQueryData(['balance']);
                    onEnd(parseFloat(updatedBalance));
                    return [2 /*return*/];
            }
        });
    }); };
    var player = document.getElementById('player');
    useLayoutEffect(function () {
        startAd();
    }, []);
    useEffect(function () {
        if (!isEnded)
            return;
        handleEnd();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEnded]);
    useEffect(function () {
        if (!error)
            return;
        GAHandler('ad_error', { error: error });
        close();
        toast(t('ads:error'), { icon: 'error' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);
    useEffect(function () {
        return function () {
            resetAd();
            resetNextReward();
        };
    }, []);
    var adRoot = (_jsxs("div", { style: {
            position: 'fixed',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            backgroundColor: 'black',
            zIndex: 99999999999,
        }, children: [_jsx("div", { ref: adContainerRef, id: videoWrapperId, style: {
                    height: '100%',
                    width: '100%',
                } }), _jsx(Button, { variant: 'tertiary', iconLeft: CloseSVG, onClick: unfinishedClose, style: {
                    position: 'absolute',
                    top: 20,
                    right: 20,
                } }), (played === 0 || isLoading) && (_jsx(Lottie, { animationData: loaderJson, loop: true, style: {
                    width: isMobileBig ? 50 : 100,
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                } }))] }));
    useEffect(function () {
        /**
         * Overflow is set visible when modal is closed.
         * So to override it, I need to use the timeout
         */
        setTimeout(function () {
            document.body.style.overflow = 'hidden';
        }, 0);
        return function () {
            document.body.style.overflow = 'visible';
        };
    }, []);
    return createPortal(adRoot, player);
};
export default PlayerInStream;
